import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import * as R from "ramda";
import * as $ from "jquery";

import { useDispatch, useSelector } from "react-redux";
import * as axios from "axios";
import { ToastContainer } from "react-toastify";

import { updateUserInfoById, updateOnboardingUserAddressById, updateOnboardingStep } from "../../../../../actions/facilita-api";

import { CivilForm } from "../../../dossier/profile/civilForm";
import { FamilySituationForm } from "../../../dossier/profile/familySituationForm";
import { ChildrenForm } from "../../../dossier/profile/childrenForm";
import { ResidenceForm } from "../../../dossier/profile/residenceForm";
import { ProfessionalSituationForm } from "../../../dossier/profile/professionalSituationForm";

export const Step1 = ({ defaultPersonalData, isLoading, subsectionsStatuses, setSubsectionsStatuses }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const [personalData, setPersonalData] = useState({ ...defaultPersonalData });
	const [isUpdating, setIsUpdating] = useState(false);

	const civilForm = useRef(null);
	const familySituationForm = useRef(null);
	const childrenForm = useRef(null);

	const professionalSituationForm = useRef(null);

	// useEffect(() => {
	//   if(!R.isNil(defaultPersonalData)){
	//     setPersonalData({...defaultPersonalData});
	//   }
	// }, [defaultPersonalData])

	const validateForms = () => {
		//CivilForm
		const naturalite = document.getElementById("naturalite");
		const departmentNumberField = document.getElementById("departmentNumber");
		if (naturalite.options[naturalite.selectedIndex].value == "FR" && departmentNumberField.options[departmentNumberField.selectedIndex].value === "") {
			departmentNumberField.setCustomValidity("Numéro de département non sélectionné");
		} else {
			departmentNumberField.setCustomValidity("");
		}

		//FamilySituationForm
		const familyStatusFilled = document.getElementById("familyStatusFilled");
		if (R.isNil(personalData.civilStatus)) {
			familyStatusFilled.setCustomValidity("Situation familiale non déclarée");
		} else {
			familyStatusFilled.setCustomValidity("");
		}

		//ChildrenFprm
		const childrenFormFilled = document.getElementById("childrenFilled");
		if (R.isNil(personalData.hasChildren)) {
			childrenFormFilled.setCustomValidity("Situation familiale non déclarée");
		} else {
			childrenFormFilled.setCustomValidity("");
		}

		//professionalSituationForm
		const professionFormFilled = document.getElementById("professionFormFilled");
		if (personalData.professionalSituation.length == 0) {
			professionFormFilled.setCustomValidity("Situation professionnelle non déclarée");
		} else {
			professionFormFilled.setCustomValidity("");
		}
	};

	useEffect(() => {
		if (!R.isNil(civilForm.current)) {
			civilForm.current.classList.remove("was-validated");
		}
		if (!R.isNil(familySituationForm.current)) {
			familySituationForm.current.classList.remove("was-validated");
		}
		if (!R.isNil(childrenForm.current)) {
			childrenForm.current.classList.remove("was-validated");
		}
		if (!R.isNil(childrenForm.current)) {
			childrenForm.current.classList.remove("was-validated");
		}
		if (!R.isNil(professionalSituationForm.current)) {
			professionalSituationForm.current.classList.remove("was-validated");
		}

		let tempSubsectionsStatuses = { ...subsectionsStatuses };

		let isCivilFormValid = true;
		const civilFormInputs = $("#CivilForm :input");
		civilFormInputs.map((index, input) => {
			if (!input.checkValidity()) isCivilFormValid = false;
		});

		if (personalData.departmentNumber === "") {
			isCivilFormValid = false;
			document.getElementById("departmentNumber").setCustomValidity("Numéro de département non sélectionné");
		}
		if (isCivilFormValid && civilFormInputs.length > 0) {
			tempSubsectionsStatuses.civilForm = true;
		} else {
			tempSubsectionsStatuses.civilForm = false;
		}

		if (!R.isNil(personalData.civilStatus)) {
			tempSubsectionsStatuses.familySituationForm = true;
		}

		if (!R.isNil(personalData.hasChildren)) {
			tempSubsectionsStatuses.childrenForm = true;
		}

		if (personalData.professionalSituation.length > 0) {
			tempSubsectionsStatuses.professionalSituationForm = true;
		}

		let isResidenceFormValid = true;
		const residenceFormInputs = $("#ResidenceForm :input");
		residenceFormInputs.map((index, input) => {
			if (!input.checkValidity()) isResidenceFormValid = false;
		});
		if (isResidenceFormValid && residenceFormInputs.length > 0) {
			tempSubsectionsStatuses.residenceForm = true;
		} else {
			tempSubsectionsStatuses.residenceForm = false;
		}
		setSubsectionsStatuses(tempSubsectionsStatuses);
	}, [personalData]);

	if (R.isNil(personalData) || R.isNil(defaultPersonalData)) {
		return "";
	}
	return (
		<article className="view-calc mb-auto">
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0">
					<h1 className="text-primary font-weight-bolder mt-2 mb-3">Informations du défunt</h1>
				</header>
			</div>
			<div className="auto-view py-4 py-lg-0 mt-lg-sm">
				<div className="container-fluid">
					<CivilForm personalData={personalData} setPersonalData={setPersonalData} formReference={civilForm} />
					<FamilySituationForm personalData={personalData} setPersonalData={setPersonalData} formReference={familySituationForm} />
					<ChildrenForm personalData={personalData} setPersonalData={setPersonalData} isLoading={isLoading} isFacilita={true} formReference={childrenForm} />
					<ResidenceForm personalData={personalData} setPersonalData={setPersonalData} />
					<ProfessionalSituationForm personalData={personalData} setPersonalData={setPersonalData} formReference={professionalSituationForm} />
				</div>
				<div className="container-fluid">
					{/* <p className="mt-auto text-muted mb-2">En cliquant sur "Passer à l'étape suivante", vous acceptez les <Link to="/legal/terms" target="_blank" className="btn-link text-info font-weight-bold text-decoration-none">Conditions générales d'utilisation et la Politique de protection des données</Link>.</p> */}
					<footer className="d-block mt-auto mb-sm text-right w-100">
						<Link to="/facilita" className="btn btn-faded px-md-gutter mr-3" onClick={() => {}}>
							Retour
						</Link>
						<button
							className={"btn btn-info px-md-gutter px-4 loading-btn" + (isUpdating ? " show" : "")}
							onClick={(event) => {
								setIsUpdating(true);
								validateForms();
								let canUpdate = true;
								if (!civilForm.current.checkValidity()) {
									civilForm.current.classList.add("was-validated");
									canUpdate = false;
								}

								if (!familySituationForm.current.checkValidity()) {
									familySituationForm.current.classList.add("was-validated");
									canUpdate = false;
								}

								if (!childrenForm.current.checkValidity()) {
									childrenForm.current.classList.add("was-validated");
									canUpdate = false;
								}

								if (!professionalSituationForm.current.checkValidity()) {
									professionalSituationForm.current.classList.add("was-validated");
									canUpdate = false;
								}

								if (canUpdate) {
									Promise.all([dispatch(updateUserInfoById(personalData)), dispatch(updateOnboardingUserAddressById(personalData.id, personalData.userResidenceAddress))]).then(() => {
										dispatch(updateOnboardingStep(personalData.id, 2));
										setIsUpdating(false);
										history.push(`/facilita/${personalData.id}/onboarding/step2`);
									});
								}
								setIsUpdating(false);
								return;
							}}>
							Passer à l'étape suivante
							<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
						</button>
					</footer>
				</div>
			</div>
		</article>
	);
};
